import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, post } from '../../utils/api';
import { DataResponse } from "services/response";


export interface ReportCTDAModel {
    stt?: number
    profileId?: string
    profileCode?: string
    profileName?: string
    nvkd?: string
    nvspec?: string
    opportunityType?: string
    createTime?: string
    handoverFurniture: any
    provinceName?: string
    scale?: number
    investorName?: string
    designName?: string
    contractorName?: string
    trungThau?: number
    rotThau?: number
    otherBrand?: string
    competitor?: string
    opportunityStatus?: string
    startTime?: string
    endTime?: string
    specs: Spec[]
    constructions: Spec[]
}

export interface Spec {
    typeOpportunity?: string
    material?: string
    signDate: string
    trungThau: number
    rotThau: number
}




// ============ Khai báo phương thức =====================
export interface IProjectManagementServices {
    // Báo cáo chi tiết dự án
    getDataCTDAReport(data: object): Promise<DataResponse<Array<ReportCTDAModel>>>
    // Xuất Excel báo cáo chi tiết dự án
    exportExportReportCTDA(dataSearch: Object): Promise<void>
}
// Hàm khởi tạo các phương thức của NKMH service
export function createProjectManagementServices(): IProjectManagementServices {
    return {
        getDataCTDAReport: async (data: object) => {
            return (
                await post(
                    BASE_API_URL,
                    `Reports/report-ctda`, data))
                .data;
        },
        // Xuất Excel báo cáo chi tiết dự án
        exportExportReportCTDA: async (dataSearch) => {
            await downloadFilePost(`Reports/export-excel-ctda`, dataSearch);
        }
    };
}
